module.exports = __webpack_public_path__ + "static/media/dingus.0e79214b.ico";